import React, { Component } from "react";
import SearchComp from "../../components/SearchComp";
import "./style.scss";

export default class Page404 extends Component {
  render() {
    return (
      <div className="page404">
        <h2>The page you are looking for was not found.</h2>
        <div className="inner">
          <h3>Sorry for inconvenience</h3>
          <p>Search again what you are looking for</p>
          <SearchComp pathname={this.props.location.pathname} />
        </div>
      </div>
    );
  }
}
